import { Logos, Constants as logoConstants } from '@comeon/vectors';

// DEPOSIT LIMITS constants
export const API_IDLE = `idle`;
export const LOADING = `loading`;
export const API_ERROR = `error`;
export const ADD_VIEW = `ADD_VIEW`;
export const API_LOADING = `pending`;
export const API_SUCCESS = `success`;
export const PROMPT_CVV = `CVV`;
export const PROMPT_ONECLICK = `PAYPAL_ONECLICK`;
export const REMOVE_VIEW = `REMOVE_VIEW`;
export const MAIN_CONTENT = `main-content`;
export const QD_REDIRECT_URL = `QDRedirectUrl`;
export const REDIRECT_LIMITS = `limits_erdirect`;
export const RESULT_VIEW = `result-view-success`;
export const RESULT_NOTIFICATION = `result-notif`;
export const INFO_MODAL = `deposit-limits-content`;
export const INPUT_MODAL = `deposit-limits-content`;
export const REDIRECT_PAYMENTS = `payments_redirect`;
export const LIMITS_REDIRECT_CONFIRM = `limits-redirect`;
export const DEPOSIT_REDIRECT_CONFIRM = `deposit-redirect`;
export const UPLOAD_DOC_REDIRECT_CONFIRM = `upload-doc-redirect`;
export const QD_EXECUTE = `qd-execute`;
export const SHUFA_CONSENT = `schufa-consent`;

// Method Name Constants
export const SWISH = 'TRUSTLY_SWISH';
export const TRUSTLY_SWISH_NORTHMILL = 'TRUSTLY_SWISH_NORTHMILL';
export const PAYPAL = 'PAYPAL';
export const TRUSTLY = 'GLUEPAY';
export const TRUSTLY_AZURA = 'TRUSTLY_AZURA';
export const ZIMPLER_SWISH = 'ZIMPLER_SWISH';
export const CREDITCARD = 'Credit Card';
export const ADYEN_MOBILEPAY = 'ADYEN_MOBILEPAY';
export const P24 = 'P24';
export const ADYEN_IDEAL = 'ADYEN_IDEAL';
export const TRUSTLY_IDEAL = 'TRUSTLY_IDEAL';

export const textKeysQD = [
	'CANCEL',
	'INSTANT_DEPOSIT_ACCEPT',
	'QUICK_DEPOSIT_SUCCESS',
	'MOBILE_DEPOSIT_LIMITS_FOOTER_INFO',
	'DEPOSIT_LIMITS_FOOTER_ADDITIONAL_INFO',
	'INSTANT_DEPOSIT_REDIRECT_CONFIRM_TEXT',
	'INSTANT_DEPOSIT_REDIRECT_CONFIRM_TITLE',
	'INSTANT_DEPOSIT_LIMIT_REDIRECT_CONFIRM_TEXT',
	'INSTANT_DEPOSIT_KYC_REDIRECT_CONFIRM_TEXT',
	'DEPOSIT_AML_SOW_LIMIT_INFO'
];

export const textKeysQDMobileToolbar = ['QUICK_DEPOSIT'];

export const textKeysQDContent = [
	'CANCEL',
	'QD_KYC_MESSAGE',
	'QD_MORE_METHODS',
	'QD_DEPOSIT_BUTTON',
	'UPDATE_DEPOSIT_LIMIT',
	'SYSTEM_ERROR_GENERAL',
	'QD_KYC_SUBTITLE_MESSAGE',
	'SELIMIT_REACHED_MESSAGE',
	'DEPOSIT_LIMITS_TEMPLATE_TITLE',
	'MOBILE_UPLOAD_DOCUMENTS_HEAD_TITLE',
	'SOW_PAGE_HEADER',
	'QD_SOW_MESSAGE',
	'MOBILE_UPLOAD_DOCUMENTS',
	'LUGAS_LIMIT_REACHED_MESSAGE',
	'LUGAS_LIMIT_REACHED_TITLE',
	'MOBILE_DEPOSIT_KYC_MESSAGE_NOT_UPLOADED'
];

export const textKeysQDAmountScreen = [
	'CANCEL',
	'AMOUNT',
	'AMOUNT_MIN',
	'AMOUNT_MAX',
	'EDIT_AMOUNT',
	'QD_CVV_INFO',
	'QD_CVV_INPUT',
	'QD_MORE_METHODS',
	'QD_CVV_CONTINUE',
	'QD_DEPOSIT_BUTTON',
	'QD_PAYPAL_ONECLICK',
	'QD_PAYPAL_CONTINUE',
	'SYSTEM_ERROR_GENERAL',
	'PAYMENT_METHOD_BRITE',
	'PAYMENT_METHOD_SWISH',
	'PAYMENT_METHOD_PAYPAL',
	'CHANGE_PAYMENT_METHOD',
	'PAYMENT_METHOD_KLARNA',
	'PAYMENT_METHOD_GLUEPAY',
	'PAYMENT_METHOD_STD_VISA',
	'PAYMENT_METHOD_OMNIMATRIX',
	'PAYMENT_METHOD_CREDIT_CARD',
	'CHANGE_PAYMENT_METHOD_LIST',
	'PAYMENT_METHOD_ADYEN_SWISH',
	'PAYMENT_METHOD_TRUSTLY_SWISH',
	'PAYMENT_METHOD_ZIMPLER_SWISH',
	'PAYMENT_METHOD_STD_MASTERCARD',
	'PAYMENT_METHOD_ADYEN_MOBILEPAY',
	'MOBILE_PAYMENT_METHOD_BANK_TRANSFER',
	'MOBILE_DEPOSIT_KYC_MESSAGE_NOT_UPLOADED',
	'MOBILE_DEPOSIT_MAX_TEXT',
	'MOBILE_DEPOSIT_LIMIT_REACHED',
	'MOBILE_BALANCE_LIMIT_REACHED',
	'MOBILE_SPEND_LIMIT_REACHED',
	'PAYMENT_METHOD_GIGADAT_INTERAC',
	'PAYMENT_METHOD_PAYPER_PAYBILT_INTERAC',
	'PAYMENT_METHOD_TRUSTLY_SWISH_NORTHMILL'
];

export const textKeysResultView = [
	'QUICK_DEPOSIT_SUCCESS',
	'QUICK_DEPOSIT_PENDING',
	'QUICK_DEPOSIT_RESULT_FAIL_TITLE',
	'QUICK_DEPOSIT_PARTIAL_SUCCESS_P1',
	'QUICK_DEPOSIT_PARTIAL_SUCCESS_P2',
	'QD_LEARN_MORE_BUTTON_TEXT'
];

export const LogoMap = {
	DEFAULT: Logos[logoConstants.DEFAULT],
	PAYMENT_METHOD_PAYPAL: Logos[logoConstants.PAYPAL],
	PAYMENT_METHOD_GLUEPAY: Logos[logoConstants.TRUSTLY],
	PAYMENT_METHOD_TRUSTLY_AZURA: Logos[logoConstants.TRUSTLY],
	PAYMENT_METHOD_TRUSTLY_SWISH: Logos[logoConstants.SWISH],
	PAYMENT_METHOD_ZIMPLER_SWISH: Logos[logoConstants.SWISH],
	PAYMENT_METHOD_TRUSTLY_SWISH_NORTHMILL: Logos[logoConstants.SWISH],
	PAYMENT_METHOD_STD_VISA: Logos[logoConstants.VISA_COLOR],
	PAYMENT_METHOD_OMNIMATRIX: Logos[logoConstants.VISA_COLOR],
	PAYMENT_METHOD_CREDIT_CARD: Logos[logoConstants.CREDIT_CARD],
	PAYMENT_METHOD_ADYEN_MOBILEPAY: Logos[logoConstants.MOBILEPAY_COLOR],
	PAYMENT_METHOD_STD_MASTERCARD: Logos[logoConstants.MASTERCARD],
	PAYMENT_METHOD_KLARNA: Logos[logoConstants.KLARNA],
	PAYMENT_METHOD_P24: Logos[logoConstants.P24_COLOR],
	PAYMENT_METHOD_ADYEN_IDEAL: Logos[logoConstants.ADYEN_IDEAL_COLOR],
	PAYMENT_METHOD_TRUSTLY_IDEAL: Logos[logoConstants.ADYEN_IDEAL_COLOR],
	PAYMENT_METHOD_PAYPER_PAYBILT_INTERAC: Logos[logoConstants.PAYPER_PAYBILT_INTERAC_COLOR],
	PAYMENT_METHOD_GIGADAT_INTERAC: Logos[logoConstants.GIGADAT_INTERAC_COLOR]
};
export const IconMap = {
	DEFAULT: Logos[logoConstants.DEFAULT_BW],
	PAYMENT_METHOD_STD_VISA: Logos[logoConstants.VISA],
	PAYMENT_METHOD_OMNIMATRIX: Logos[logoConstants.VISA],
	PAYMENT_METHOD_PAYPAL: Logos[logoConstants.PAYPAL_BW],
	PAYMENT_METHOD_GLUEPAY: Logos[logoConstants.TRUSTLY_BW],
	PAYMENT_METHOD_TRUSTLY_AZURA: Logos[logoConstants.TRUSTLY_BW],
	PAYMENT_METHOD_TRUSTLY_SWISH: Logos[logoConstants.SWISH_BW],
	PAYMENT_METHOD_ZIMPLER_SWISH: Logos[logoConstants.SWISH_BW],
	PAYMENT_METHOD_TRUSTLY_SWISH_NORTHMILL: Logos[logoConstants.SWISH_BW],
	PAYMENT_METHOD_CREDIT_CARD: Logos[logoConstants.CREDIT_CARD_BW],
	PAYMENT_METHOD_ADYEN_MOBILEPAY: Logos[logoConstants.MOBILEPAY],
	PAYMENT_METHOD_STD_MASTERCARD: Logos[logoConstants.MASTERCARD_BW],
	PAYMENT_METHOD_KLARNA: Logos[logoConstants.KLARNA_BW],
	PAYMENT_METHOD_P24: Logos[logoConstants.P24_WHITE],
	PAYMENT_METHOD_ADYEN_IDEAL: Logos[logoConstants.ADYEN_IDEAL_BW],
	PAYMENT_METHOD_TRUSTLY_IDEAL: Logos[logoConstants.ADYEN_IDEAL_BW],
	PAYMENT_METHOD_PAYPER_PAYBILT_INTERAC: Logos[logoConstants.PAYPER_PAYBILT_INTERAC_BW],
	PAYMENT_METHOD_GIGADAT_INTERAC: Logos[logoConstants.GIGADAT_INTERAC_BW]
};
